import React from 'react'

import { createBrowserRouter } from 'react-router-dom'

import { ChangeEmailRoute } from './ChangeEmailRoute'
import { ForgotPasswordRoute } from './ForgotPasswordRoute'
import { ResetPasswordRoute } from './ResetPasswordRoute'
import { LoginSuccessRoute } from './LoginSuccessRoute'
import { SentryReactTestRoute } from './SentryReactTestRoute'
import { SignInPartnerRoute } from './SignInPartnerRoute'
import { SignInIOSRoute } from './SignInIOSRoute'
import { SignInRoute } from './SignInRoute'
import { SignInMobileRoute } from './SignInMobileRoute'
import { CareAuthenticationRequestRoute } from './CareAuthenticationRequestRoute'
import { TwoStepVerificationPushResponseRoute } from './TwoStepVerificationPushResponseRoute'
import { TwoStepVerificationTesterRoute } from './TwoStepVerificationTesterRoute'
import { SignInAndroidRoute } from './SignInAndroidRoute'
import { PasskeyManagementRoute } from './PasskeyManagementRoute'
import { TrustedDeviceManagementRoute } from './TrustedDeviceManagementRoute'
import { ProfileRoute } from './ProfileRoute'

export const router = createBrowserRouter([
  {
    path: '/signin',
    element: <SignInRoute />,
  },
  {
    path: '/signin/mobile',
    element: <SignInMobileRoute />,
  },
  {
    path: '/signin/ios',
    element: <SignInIOSRoute />,
  },
  {
    path: '/signin/android',
    element: <SignInAndroidRoute />,
  },
  {
    path: '/forgot_password',
    element: <ForgotPasswordRoute />,
  },
  {
    path: '/reset_password',
    element: <ResetPasswordRoute />,
  },
  {
    path: '/care_authentication_request',
    element: <CareAuthenticationRequestRoute />,
  },
  {
    path: '/two_step_verification/push/response',
    element: <TwoStepVerificationPushResponseRoute />,
  },
  {
    path: '/two_step_verification_tester',
    element: <TwoStepVerificationTesterRoute />,
  },
  {
    path: '/signin_partner',
    element: <SignInPartnerRoute />,
  },
  {
    path: '/change_email',
    element: <ChangeEmailRoute />,
  },
  {
    path: '/profile/passkey_management',
    element: <PasskeyManagementRoute />,
  },
  {
    path: '/profile/trusted_device_management',
    element: <TrustedDeviceManagementRoute />,
  },
  {
    path: '/admin/debug/sentry_react_test',
    element: <SentryReactTestRoute />,
  },
  {
    path: '/login_success',
    element: <LoginSuccessRoute />,
  },
  {
    path: '/profile',
    element: <ProfileRoute />,
  },
])
